<script>
  import { MAP_NOTIFICATION_TYPES } from '@notify/models/notification';
  import DatabaseExportComplete from '@notify/components/notifications/notifications-database-export-complete';
  import MailingExportComplete from '@notify/components/notifications/notifications-maling-export-complete';
  import VoiceExportComplete from '@notify/components/notifications/notifications-voice-export-complete';
  import RecordingExportComplete from '@notify/components/notifications/notifications-recording-export-complete';
  import InformerExportComplete from '@notify/components/notifications/notifications-informer-export-complete';
  import NotificationsSenders from '@notify/components/notifications/notifications-senders';
  import NotificationsMailings from '@notify/components/notifications/notifications-mailings';
  import NotificationsDefault from '@notify/components/notifications/notifications-default-type';
  import i18nBody from '@notify/components/notifications/notifications-table-cell-i18n';

  function isDatabaseExportComplete(type) {
    return MAP_NOTIFICATION_TYPES.database_export_complete === type;
  }

  function isMailingExportComplete(type) {
    return MAP_NOTIFICATION_TYPES.mailing_export_complete === type;
  }

  function isVoiceExportComplete(type) {
    return MAP_NOTIFICATION_TYPES.voice_export_complete === type;
  }

  function isRecordingExportComplete(type) {
    return MAP_NOTIFICATION_TYPES.recording_export_complete === type;
  }

  function isInformerExportComplete(type) {
    return MAP_NOTIFICATION_TYPES.informer_export_complete === type;
  }

  function isPredictiveExportComplete(type) {
    return MAP_NOTIFICATION_TYPES.predictive_export_stats_complete === type;
  }
  function isNotificationsSenders(type) {
    return MAP_NOTIFICATION_TYPES.senders_update === type;
  }

  function isNotificationsMailings(type) {
    return MAP_NOTIFICATION_TYPES.mailings_update === type;
  }

  function isNotEhoughMoney(type) {
    return MAP_NOTIFICATION_TYPES.not_enough_money === type;
  }

  export default {
    functional: true,
    props: {
      item: {
        required: true,
        type: Object
      }
    },
    render(h, context) {
      const item = context.props.item;
      const default_props = {
        props: {
          ...item.i18n_props
        }
      };

      if (item.is_custom || context.props.item.type === 'custom') {
        return h('div', { domProps: { innerHTML: item.text } });
      }

      // потому что одинаково в таблице и в плашке хедера
      if (isDatabaseExportComplete(item.type) || isPredictiveExportComplete(item.type)) {
        return h(DatabaseExportComplete, default_props);
      }

      if (isMailingExportComplete(item.type)) {
        return h(MailingExportComplete, default_props);
      }

      if (isVoiceExportComplete(item.type)) {
        return h(VoiceExportComplete, default_props);
      }

      if (isInformerExportComplete(item.type)) {
        return h(InformerExportComplete, default_props);
      }

      if (isRecordingExportComplete(item.type)) {
        return h(RecordingExportComplete, default_props);
      }

      if (isNotificationsSenders(item.type)) {
        return h(NotificationsSenders, default_props);
      }

      if (isNotificationsMailings(item.type)) {
        return h(NotificationsMailings, default_props);
      }
      if (isNotEhoughMoney(item.type)) {
        return h(NotificationsDefault, default_props);
      }

      return h(i18nBody, default_props);
    }
  };
</script>
